import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  Empty, Result, Spin,
} from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import { captureException } from '@sentry/react';
import useHttpClient from '/src/hooks/useHttpClient';
import Router from '/src/constants/router';

import YoutubeConnect from '/src/components/YoutubeConnect';
import { generateUrl } from '/src/utils/http';
import GetInfo from '/src/components/GetInfo';
import { UploadContext } from '/src/constants/contexts';
import { UPLOAD_API_BASE_URL } from '/src/constants';
import useUser from '../hooks/useUser';
import useUploadQuota from '../hooks/useUploadQuota';
import Loading from '../components/loading';

function NewVideo() {
  const httpClient = useHttpClient({ baseURL: UPLOAD_API_BASE_URL });
  const { data: user, isLoading: loading, mutate } = useUser();
  const { quota } = useUploadQuota();
  const uploadDisabled = Boolean(quota?.disabled);
  const hasPermission = user?.channels?.some?.((ch) => ch.scope?.includes('youtube.upload'));
  const [unpublishedVideo, setUnpublishedVideo] = useState();
  const { setVideo } = useContext(UploadContext);
  useEffect(() => {
    if (!hasPermission || !user?.phoneNumber || uploadDisabled) {
      return;
    }
    httpClient.get(generateUrl({
      url: '/videos',
      query: {
        _page_size: 2,
        _sort: 'id',
        _order: 'DESC',
        _attributes: 'id,s3,filename,title,state,fileState',
      },
    })).then(({ data: { data: videos } }) => {
      const video = videos.find((v) => v.state !== 'PUBLISHED' && v.state !== 'EXPIRED');
      if (video) { setUnpublishedVideo(video); } else (createVideo());
    }).catch(captureException);
  }, [hasPermission, user?.phoneNumber, uploadDisabled]);

  // if (isUploading) {
  //   Router.navigate(`/videos/${uploadingVideo.id}`);
  //   return null;
  // }

  function createVideo() {
    setVideo(null);
    return httpClient.post('videos').then((res) => Router.navigate(`/videos/${res.data.data.id}`)).catch(captureException);
  }
  // return (
  //   <Result
  //     icon={<HddOutlined />}
  //     title={(
  //       <div>
  //         سرویس آپلود جهت ارتقا موقتا خاموش می‌باشد
  //         <br />
  //         به زودی برمیگردیم :)
  //       </div>
  //     )}
  //   />
  // );
  if (loading)
    return <Loading size="fill" text="درحال بارگذاری..." />
  if (uploadDisabled) {
    return (
      <Result
        status="warning"
        title="آپلود غیرفعال است"
        subTitle="آپلود ویدیو برای حساب شما غیرفعال شده است."
        extra={(
          <Button type="primary" onClick={() => Router.navigate('/videos')}>
            بازگشت به ویدیوها
          </Button>
        )}
      />
    );
  }
  if (!loading && !user?.phoneNumber) {
    return (
      <GetInfo phoneNumber={user?.phoneNumber} onUpdate={mutate} />
    );
  }
  if (!loading && !hasPermission) {
    return (
      <YoutubeConnect permissions={['youtube.upload']} />
    );
  }
  if (unpublishedVideo) {
    if (!unpublishedVideo.filename) {
      Router.navigate(`/videos/${unpublishedVideo.id}`);
      return <Empty image={<Spin size="large" />} description="درحال بارگذاری" />;
    }
    return (
      <Result
        icon={<FileSearchOutlined />}
        status="info"
        title="آپلود ناتمام"
        subTitle={`یک فایل آپلود نشده به اسم "${unpublishedVideo.filename}" از قبل وجود دارد، آن را ادامه می‌دهید؟`}
        extra={[
          <Button key="1" className="my-1" type="primary" size="large" onClick={() => Router.navigate(`/videos/${unpublishedVideo.id}`)}>ادامه آپلود</Button>,
          <Button key="2" className="my-1" size="large" onClick={createVideo}>ایجاد آپلود جدید </Button>,
        ]}
      />
    );
  }
  return (
    <Empty image={<Spin size="large" />} description="درحال بارگذاری" />
  );
}

export default NewVideo;
